import { skills } from "./data";


export default function Skills() {
  return (
    <section id="skills">
      <div className="skills">
        <div className="skillsHeading">
         <h1><span>My</span>Skills</h1>
        </div>
        <div className="skills-container">
          {skills.map((skill) => (
            <div key={skill} className="skills-cont">
                <div className="card-top">
                  <img
                  alt="skill picture"
                  className=""
                  src={skill  .image}
                />
                <h1>{skill.title}</h1>
                </div>
              
                
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
